import {
  type DeliveryAddressDraft,
  type DeliveryAddressId,
  podOrderApi,
} from '@mathflat/domain/PodOrder'

import type { DeliveryAddressRepository } from './DeliveryAddressRepository'

export class ApiDeliveryAddressRepository implements DeliveryAddressRepository {
  list() {
    return podOrderApi.getDeliveryAddressBook()
  }

  create(draft: DeliveryAddressDraft) {
    return podOrderApi.createDeliveryAddress(draft)
  }

  update(id: DeliveryAddressId, draft: DeliveryAddressDraft) {
    return podOrderApi.updateDeliveryAddress(id, draft)
  }

  remove(id: DeliveryAddressId) {
    return podOrderApi.deleteDeliveryAddress(id)
  }
}
